module.exports = __webpack_public_path__ + "static/assets/epic-games-logo.926e9c1.png";